function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M24,48A24.006,24.006,0,0,1,14.658,1.886,24.006,24.006,0,0,1,33.342,46.114,23.849,23.849,0,0,1,24,48Zm4.38-24.217c1.257,0,2.756.641,2.756,3.694V36.22h5.439V26.85a7.943,7.943,0,0,0-1.789-5.56,5.891,5.891,0,0,0-4.473-1.8,5.62,5.62,0,0,0-3.263.932,6.1,6.1,0,0,0-1.639,1.767V19.878h-5.44c.071,1.516,0,16.193,0,16.341h5.44V27.094a3.6,3.6,0,0,1,.179-1.326,3.387,3.387,0,0,1,.979-1.359A2.8,2.8,0,0,1,28.381,23.783ZM11.522,19.877V36.22h5.439V19.877ZM14.277,12a2.832,2.832,0,1,0-.07,5.648h.035a3.171,3.171,0,0,0,2.25-.824,2.735,2.735,0,0,0,.827-2A2.821,2.821,0,0,0,14.277,12Z",
  fill: "#fff"
});

function SvgLinkedInBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedInBlack);
export default __webpack_public_path__ + "static/media/LinkedIN_black.25a13034.svg";
export { ForwardRef as ReactComponent };